export enum Api401ErrorCode {
	ULK = 'ULK', //User profile locked out
	EXC = 'EXC', //General Exception
	UEX = 'UEX', //User cannot be created. Exception when user is created (double api call)
	LNF = 'LNF', //Location not found. (Practice || Ministry) not registered
	INR = 'INR', //Invalid Role. Role is not SSM Role
	INS = 'INS' //Invalid status e.g. DEACTIVATED, PASS_RESET, NEW, PRE_REGISTERED, REACTIVATED
}
